import styled from "styled-components";

export interface RouterOutletBoxProps {
    minHeight: string;
}

export const RouterOutletDefaultBox = styled.div<RouterOutletBoxProps>`
  background-color: ${props => props.theme.colors.background};
  min-height: ${props => props.minHeight};
  
`